module.exports = __webpack_public_path__ + "icon-sms-3d57ba28.png";